import React, { useEffect } from 'react';
import { Button, Drawer, Form, Input, InputNumber, Select } from 'antd';
import type { FormInstance } from 'antd';

export interface EpcEstimateBoqAddDrawerProps {
  open: boolean;
  onClose: () => void;
  form: FormInstance;
  readOnly?: boolean;
  lines: Array<{ id: string; item_number?: string; description?: string }>;
  onSubmit: (values: Record<string, unknown>) => void;
  pending?: boolean;
  defaultParentId?: string | null;
}

export const EpcEstimateBoqAddDrawer: React.FC<EpcEstimateBoqAddDrawerProps> = ({
  open,
  onClose,
  form,
  readOnly,
  lines,
  onSubmit,
  pending,
  defaultParentId,
}) => {
  useEffect(() => {
    if (open) {
      form.resetFields();
      if (defaultParentId) form.setFieldsValue({ parentId: defaultParentId });
    }
  }, [open, defaultParentId, form]);

  return (
    <Drawer
      title="Add client BOQ line"
      open={open}
      onClose={onClose}
      width={420}
      destroyOnClose
      extra={
        !readOnly ? (
          <Button type="primary" loading={pending} onClick={() => form.submit()}>
            Add
          </Button>
        ) : null
      }
    >
      <Form
        form={form}
        layout="vertical"
        disabled={readOnly}
        onFinish={(v) => {
          onSubmit(v);
          onClose();
        }}
      >
        <Form.Item name="itemNumber" label="Item #">
          <Input placeholder="e.g. 1.2.3" />
        </Form.Item>
        <Form.Item name="description" label="Description" rules={[{ required: true }]}>
          <Input.TextArea rows={2} placeholder="Scope description" />
        </Form.Item>
        <Form.Item name="quantity" label="Quantity" initialValue={1}>
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="unitRate" label="Unit rate" initialValue={0}>
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="parentId" label="Parent line">
          <Select
            allowClear
            placeholder="Optional parent"
            options={lines.map((n) => ({
              value: n.id,
              label: n.item_number || n.description || n.id.slice(0, 8),
            }))}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};
